var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FDC134"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.28069 8.46509H15.3756C19.0828 8.46509 21.8931 10.4577 22.9386 13.3573H24.8372V15.1099H23.3385C23.3678 15.3868 23.3828 15.669 23.3828 15.9556V15.9987C23.3828 16.3214 23.3638 16.6387 23.3267 16.9494H24.8372V18.702H22.9024C21.8294 21.5612 19.0411 23.5349 15.3756 23.5349H9.28069V18.702H7.16278V16.9494H9.28069V15.1099H7.16278V13.3573H9.28069V8.46509ZM10.9846 18.702V21.9628H15.3756C18.0852 21.9628 20.0983 20.6567 21.0356 18.702H10.9846ZM21.5575 16.9494H10.9846V15.1099H21.5602C21.5994 15.3994 21.6195 15.6961 21.6195 15.9987V16.0417C21.6195 16.3513 21.5985 16.6543 21.5575 16.9494ZM15.3756 10.0347C18.0977 10.0347 20.117 11.3751 21.0484 13.3573H10.9846V10.0347H15.3756Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDai);
export default __webpack_public_path__ + "static/media/DAI.2bd7d535c1b1197e7155d680d5ea2053.svg";
export { ForwardRef as ReactComponent };